import React from 'react';
import {
  CNPJInput,
  LabelInput,
  CellphoneInput,
  LabelRadios,
} from '../../components/Input/Input';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { DefaultButton } from '../../components/Button/Button';
import { BsFillTrashFill } from 'react-icons/bs';
import { isMobile } from 'react-device-detect';
import { STATUS_OPTIONS } from '../../core/constants/financial';
import './modalSuppliers.scss';

const ModalSuppliers = ({
  onSave,
  closeModal,
  onChange,
  values,
  isNew,
  compareValues,
  onRemove,
}) => {
  return (
    <div className="modal-container">
      <div className="modal-header">
        <div className="header-title">
          <h4 className="modal-title">
            {isNew ? 'Adicionar Fornecedor' : 'Editar Fornecedor'}
          </h4>
        </div>
        <div className="header-buttons">
          {compareValues ? (
            <DefaultButton
              className="modal-footer-button"
              label={isMobile ? '' : 'Salvar'}
              icon={<AiOutlineCheck className="button-icon" />}
              onClick={onSave}
            />
          ) : (
            <div />
          )}
          <DefaultButton
            className="modal-footer-button cancel"
            label={isMobile ? '' : 'Cancelar'}
            icon={<AiOutlineClose className="button-icon-cancel" />}
            onClick={closeModal}
          />
        </div>
      </div>

      <div className="desc-input company">
        <LabelInput
          value={values.name}
          onChange={(value) => onChange('name', (value || '').toUpperCase())}
          placeholder={'Insira o nome ou razão social'}
          label={'Nome / Razão social*'}
        />
        <CNPJInput
          value={values.cpf_cnpj}
          onChange={(value) => onChange('cpf_cnpj', value)}
          placeholder={'Insira o CPF ou CNPJ'}
          label={'CPF / CNPJ'}
        />
        <LabelInput
          value={values.email}
          onChange={(value) => onChange('email', value)}
          placeholder={'Insira o e-mail'}
          label={'E-mail'}
        />
        <CellphoneInput
          value={values.phone}
          onChange={(value) => onChange('phone', value)}
          placeholder={'Insira o telefone'}
          label={'Telefone'}
          mask="(99) 99999-9999"
        />
        <div className="supplier-status-field">
          <label className="label">Status</label>
          <LabelRadios
            className="custom-radio"
            options={STATUS_OPTIONS}
            value={STATUS_OPTIONS.find(
              (o) => o.value === (values.status || 'ativo')
            )}
            onClick={(opt) => onChange('status', opt.value)}
          />
        </div>
        <LabelInput
          type={'textarea'}
          value={values.observation}
          onChange={(value) => onChange('observation', value)}
          placeholder={'Insira a observação'}
          inputClassname={'text-area-min'}
          label={'Observação'}
        />
      </div>

      {values && !values.id ? (
        <div />
      ) : (
        <DefaultButton
          className="modal-footer-button delete"
          label={'Excluir'}
          icon={<BsFillTrashFill className="button-icon-cancel" />}
          onClick={onRemove}
        />
      )}
    </div>
  );
};

export default ModalSuppliers;
